import React from 'react'

const AboutUs = () => {
    return (
        <div className="text-6xl font-bold">
            About Us
        </div>
    )
}

export default AboutUs